import { TriangleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from 'components/ui/button';
import Image from 'assets/images/questionnaire/questionnaire.png';
import { ScrollArea } from 'components/ui/scroll-area';

export default function RiskCheckerIntro({ onView }: { onView: () => void }) {
  const { t } = useTranslation();

  return (
    <div className='max-w-5xl px-4 mx-auto my-8'>
      <ScrollArea className='h-full sm:h-[calc(100vh-5rem)] lg:h-[calc(100vh-8rem)]'>
        <div className='relative grid h-full grid-cols-1 gap-4 pb-4 space-y-4 lg:grid-cols-2'>
          <div className='flex flex-col justify-center order-2 h-full space-y-6 sm:px-4 lg:px-6 xl:px-12 lg:order-1'>
            <div className='space-y-2'>
              <h1 className='text-lg font-semibold text-center lg:text-xl md:text-start'>
                {t('risk_intro_title')}
              </h1>
              <p className='font-medium text-gray-600'>
                {t('risk_intro_desc')}
              </p>
            </div>

            <div className='p-4 space-y-2 text-sm rounded-lg bg-[#FFE4E6]'>
              <div className='flex items-center justify-between'>
                <h4 className='font-semibold text-[#F43F5E]'>
                  {t('risk_info_card_title')}
                </h4>
                <TriangleAlert className='text-[#F43F5E] size-4' />
              </div>
              <p className='font-medium text-gray-600'>
                {t('risk_info_card_desc')}
              </p>
            </div>

            <div className='flex flex-col items-center justify-center gap-4 lg:flex-row'>
              <Button
                size='sm'
                className='w-full px-6 md:w-auto'
                onClick={onView}
              >
                {t('check_risk_now')}
              </Button>
            </div>
          </div>
          <div className='flex items-center justify-center order-1 mb-8 lg:order-2'>
            <img
              src={Image}
              alt='question'
              className='object-cover h-[200px] lg:h-1/2 xl:h-3/5 aspect-square'
            />
          </div>
        </div>
      </ScrollArea>
    </div>
  );
}
